var _rect, _rect2, _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26.3077,
    rx: 4,
    fill: "#20C3FF",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 25.6,
    height: 25.9077,
    rx: 3.8,
    stroke: "#20C3FF",
    strokeOpacity: 0.07,
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10885 19.5961H16.845C18.1463 19.5961 19.2038 18.5367 19.2038 17.2344C19.2038 16.9686 18.9885 16.7526 18.7223 16.7526C18.4561 16.7526 18.2408 16.9686 18.2408 17.2344C18.2408 18.0052 17.6139 18.6325 16.845 18.6325H9.10885C8.33992 18.6325 7.71301 18.0052 7.71301 17.2344V9.48771C7.71301 8.71689 8.33993 8.08962 9.10885 8.08962C9.37505 8.08962 9.59035 7.87353 9.59035 7.6078C9.59035 7.34206 9.37505 7.12598 9.10885 7.12598C7.8075 7.12598 6.75 8.18543 6.75 9.48771V17.2344C6.75 18.5367 7.80752 19.5961 9.10885 19.5961Z",
    fill: "#20C3FF",
    stroke: "#20C3FF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2126 13.9981C10.1861 14.0247 10.168 14.0555 10.1554 14.0893L9.26189 16.7679C9.23416 16.85 9.25586 16.9412 9.31736 17.0045C9.36076 17.0492 9.42105 17.0728 9.48074 17.0728C9.50545 17.0728 9.52836 17.0698 9.55188 17.0619L12.2623 16.2028C12.2979 16.192 12.3305 16.172 12.3564 16.1455L18.9005 9.59053C19.492 9.00011 19.492 8.03548 18.9005 7.44372C18.3091 6.85209 17.3476 6.85209 16.7567 7.44372L10.2126 13.9981ZM9.84548 16.4817L10.4767 14.5916L11.7596 15.8763L9.84553 16.4824L9.84548 16.4817ZM12.1931 15.6534L10.7034 14.1617L15.9031 8.95485L17.3928 10.4466L12.1931 15.6541V15.6534ZM17.7202 10.1188L16.2305 8.62706L16.6579 8.19904L18.1476 9.69078L17.7202 10.1188ZM17.0841 7.77215C17.2831 7.57293 17.549 7.46306 17.8299 7.46306C18.1108 7.46306 18.3749 7.57293 18.5738 7.77215C18.7728 7.97016 18.8825 8.23579 18.8825 8.51712C18.8825 8.79844 18.7728 9.06407 18.5738 9.26208L18.475 9.36229L16.9853 7.87056L17.0841 7.77155V7.77215Z",
    fill: "#20C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1931 15.6534L10.7034 14.1617L15.9031 8.95485L17.3928 10.4466L12.1931 15.6541V15.6534Z",
    fill: "#20C3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0841 7.77215C17.2831 7.57293 17.549 7.46306 17.8299 7.46306C18.1108 7.46306 18.3749 7.57293 18.5738 7.77215C18.7728 7.97016 18.8825 8.23579 18.8825 8.51712C18.8825 8.79844 18.7728 9.06407 18.5738 9.26208L18.475 9.36229L16.9853 7.87056L17.0841 7.77155V7.77215Z",
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDetailIcon);
export default __webpack_public_path__ + "static/media/caseDetailIcon.9cb65c70ca72864ffd361b6e6ef45d60.svg";
export { ForwardRef as ReactComponent };